module.exports = ":host {\n  position: relative; }\n\nth:nth-of-child(3),\nth:nth-of-child(4),\ntd:nth-of-child(3),\ntd:nth-of-child(4) {\n  text-align: right; }\n\nth:last-child,\ntd:last-child {\n  text-align: right; }\n\n.total {\n  font-size: 1.8em;\n  font-weight: 600; }\n"


//////////////////
// WEBPACK FOOTER
// ./resources/themes/pandax/bobtail/app/display-quote/display-quote.component.sass
// module id = 219
// module chunks = 1 2